// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"5f6fc280","158":"15cf6f38","168":"79d47721","396":"e0240847","420":"3cdea37e","655":"493e975e"}[chunkId] + ".chunk.css";
};